// extracted by mini-css-extract-plugin
module.exports = {"Block":"InMenu_Block__3IAJ_","Card":"InMenu_Card__3Jg5A","ButtonBlock":"InMenu_ButtonBlock__kkD20"};